module.exports = __webpack_public_path__ + "static/media/calendar.682a226b.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/products/artist/assets/calendar.png
// module id = 240
// module chunks = 0